import {convertAmountToInt} from './accounting.helper';
import {getCompletePaymentHistory} from './accounting.service';
import {handleAlert} from './sagaHelper';
import {getContractsArray, getCustomerId} from './selectors';

import {
  GET_ACCOUNTING_PAYMENT_HISTORY,
  PAYMENT_HISTORY_UNAVAILABLE,
  SET_TOTAL_ON_ACCOUNT_PAYMENT,
  SET_TOTAL_ON_ACCOUNT_WITH_CONTRACT_NUMBER,
} from '../actions';

import {all, call, put, select, takeEvery} from 'redux-saga/effects';

export function* getPaymentHistory({data}) {
  const customerId = yield select(getCustomerId);
  const contractsArray = yield select(getContractsArray);

  const responses = yield all(
    (contractsArray || []).map((contract) => {
      const contractNumber = contract?.contractNumber || contract;
      return call(getCompletePaymentHistory, customerId, contractNumber);
    })
  );
  let onAccountPaymentWithContractNumber = [];
  let paymentHistoryUnavailableContracts = [];
  let totalOnAccountPaymentMade = 0;

  responses?.forEach((response) => {
    const contractNumber = response.contractNumber;
    const customerId = response.customerId;
    const apiResponse = response.response;
    let contractVsOnAccountMade = {};
    contractVsOnAccountMade['contractNumber'] = contractNumber;
    contractVsOnAccountMade['customerId'] = customerId;

    if (
      apiResponse &&
      !apiResponse.isPaymentsHistoryCurrentlyUnavailable &&
      apiResponse?.paymentHistory
    ) {
      let totalOnAccountPaymentMadePerContract = 0;
      apiResponse?.paymentHistory?.forEach((payment) => {
        const advanceAmount = parseFloat(
          convertAmountToInt(payment.onAccountAmount)
        );
        totalOnAccountPaymentMadePerContract =
          totalOnAccountPaymentMadePerContract + advanceAmount;
        totalOnAccountPaymentMade = totalOnAccountPaymentMade + advanceAmount;
      });

      contractVsOnAccountMade['totalOnAccountPaymentForContract'] =
        totalOnAccountPaymentMadePerContract;
      onAccountPaymentWithContractNumber.push(contractVsOnAccountMade);
    } else {
      paymentHistoryUnavailableContracts.push({contractNumber, customerId});
    }
  });

  yield put({
    type: PAYMENT_HISTORY_UNAVAILABLE,
    paymentHistoryUnavailableContracts,
  });

  if (totalOnAccountPaymentMade) {
    yield put({type: SET_TOTAL_ON_ACCOUNT_PAYMENT, totalOnAccountPaymentMade});

    yield put({
      type: SET_TOTAL_ON_ACCOUNT_WITH_CONTRACT_NUMBER,
      onAccountPaymentWithContractNumber,
    });
    // yield call(handleAlert, {variant: 'success', type: 'addCropSuccess'});
  } else {
    yield call(handleAlert, {variant: 'error', type: 'alertError'});
  }
}

export function* accountingWatcher() {
  yield takeEvery(GET_ACCOUNTING_PAYMENT_HISTORY, getPaymentHistory);
}
